import { bridgeAngularJS, permanent } from "../../../config";

// try and load from Session Storage
var auth_state = sessionStorage.getItem("auth_state");

if (permanent) {
    auth_state = localStorage.getItem("auth_state");
}

if (!auth_state) {
    var angularJSUser = {};
    var token = null;

    // Load angularJS settings if they are already there!
    if (bridgeAngularJS === true) {
        angularJSUser = localStorage.getItem("ngStorage-user");

        if (angularJSUser) {
            if (process.env.NODE_ENV === "development") {
                console.log("Using AngularJS Credentials!");
            }

            angularJSUser = JSON.parse(angularJSUser);
            token = localStorage.getItem("ngStorage-token");
            if (token) token = JSON.parse(token);
        } else {
            angularJSUser = {};
        }
    }

    auth_state = {
        user: angularJSUser,
        token: token,
        refreshing_token: false,
        permissions: null,
        use_permissions: false,
        permanent: permanent,
    };
} else {
    auth_state = JSON.parse(auth_state); // parse it
}

export default auth_state;
